import { render, staticRenderFns } from "./relatorio-manutencao.vue?vue&type=template&id=77a00223&"
import script from "./relatorio-manutencao.vue?vue&type=script&lang=ts&"
export * from "./relatorio-manutencao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports